module.exports = __webpack_public_path__ + "assets/img/banner-menu-540.jpg";